import { useIsHydrated } from '~/App/shared/hooks/useIsHydrated';
import { BUSINESS_TIME_ZONE } from '~/helpers/timezone';

export const useDisplayTimeZone = (): string | undefined =>
  useIsHydrated() ? undefined : BUSINESS_TIME_ZONE;
